import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectBrokerMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_TEXT_MESSAGE);
        this.ID = null;
        this.Text = null;
        this.TextMessageType = null;
        this.SenderID = null;
        this.TargetID = null;
        this.Date = null;
        this.Name = null;
        this.ColorHEX = null;
        this.ProductID = null;
        this.ShowPopUp = null;
        this.IsUnread = null;
        this.ResponseCases = null;
        this.CustomButtons = null;
        this.DisplayMethod = TextDisplayMethod.Text;
        this.ClusterNode = null;
    }
    AddCustomButton(brokerMessageCustomButton) {
        if (!brokerMessageCustomButton) {
            return;
        }
        if (!this.CustomButtons) {
            this.CustomButtons = [];
        }
        this.CustomButtons.push(brokerMessageCustomButton);
    }
    IsHTMLDisplayMethod() {
        return this.DisplayMethod === TextDisplayMethod.Html;
    }
}
var TextDisplayMethod;
(function (TextDisplayMethod) {
    TextDisplayMethod[TextDisplayMethod["Text"] = 0] = "Text";
    TextDisplayMethod[TextDisplayMethod["Html"] = 1] = "Html";
})(TextDisplayMethod || (TextDisplayMethod = {}));
